<template>
    <div>
        <h2 class="title">API Token</h2>
        <div v-if="statusCanceled" class="message is-danger m-t-md">
            <div class="message-body">
                Your API token has been revoked due to your account being canceled.
            </div>
        </div>
        <div v-else-if="!canViewApiTokens" class="message is-warning m-t-md">
            <div class="message-body">
                You will first need to be approved by {{$store.state.dealer_portal.settings.brand_name}} before you can
                access your API token.
            </div>
        </div>
        <div v-else>
            <loading v-if="loading"></loading>
            <div v-else-if="!token" class="message is-warning m-t-md">
                <div class="message-body">
                    {{this.$store.state.dealer_portal.settings.brand_name}} either hasn't granted you API access yet or your API access has been revoked.
                </div>
            </div>
            <div v-else>
                <div class="token flex-con sm-pad-lr is-grow">
                    <div>
                        <input
                            class="actual-token"
                            :value="token.token"
                            ref="token"
                            @click="$refs.token.select()"
                            @keypress="$event.preventDefault()"
                        />
                        <div v-show="token.regeneratedAt" class="is-size-7">
                            Regenerated
                            <timestamp :value="token.regeneratedAt"></timestamp>
                        </div>
                    </div>
                    <div class="has-text-right is-narrow">
                        <button class="button is-link" :class="{'is-loading' : token.loading }" @click="confirmRegenerateToken(token)">
                            Regenerate
                        </button>
                    </div>
                </div>

                <confirm-modal
                    :active="regenerateTokenHelper.active"
                    :callback="regenerateTokenHelper.callback"
                    :loading="regenerateTokenHelper.loading"
                    :close="() => { regenerateTokenHelper.active = false}"
                >
                    <div class="has-text-centered">
                        <h5 class="title is-size-5">Are you sure you want to regenerate your API token?</h5>
                        <p>
                            Any 3rd party services using the current token will cease working and will need to be updated
                            with the newly generated token to keep functioning.
                        </p>
                    </div>
                </confirm-modal>

            </div>
        </div>
    </div>
</template>

<script>
import ApiToken from "../../../api/ApiToken";
import StatusUtil from "../../../util/StatusUtil";
import AccountSettingsMixin from "../../../mixins/AccountSettingsMixin";

export default {
    name : "ApiToken",
    mixins : [AccountSettingsMixin],
    data () {
        return {
            loading : false,
            token : null,
            regenerateTokenHelper : {
                active : false,
                loading : false,
                callback : () => {},
            },
        }
    },
    beforeMount () {
        if(this.canViewApiTokens) {
            this.loading = true;
            ApiToken.get().then(response => {
                this.token = response.data;
            }).finally(() => {
                this.loading = false;
            });
        }
    },

    computed : {
        canViewApiTokens () {
            //not pending and not denied
            return [StatusUtil.DEALER.PENDING.id, StatusUtil.DEALER.DENIED.id].indexOf(this.$getDealer().accountDealerStatusId) === -1;
        },
        statusCanceled () {
            return this.$getDealer().accountDealerStatusId === StatusUtil.DEALER.CANCELED.id;
        },
    },

    methods : {
        confirmRegenerateToken (token) {
            this.regenerateTokenHelper.callback = (yes) => {
                if(yes){
                    this.regenerateTokenHelper.loading = true;
                    this.regenerateToken(token).then(() => {
                        this.regenerateTokenHelper.loading = false;
                        this.regenerateTokenHelper.active = false;
                    });
                } else {
                    this.regenerateTokenHelper.active = false;
                }
            };
            this.regenerateTokenHelper.active = true;
        },

        regenerateToken (token) {
            this.loading = true;
            return ApiToken.regenerate(token.id).then(response => {
                this.token = response.data;
            }).finally(() => {
                this.loading = false;
            });
        },

    }

}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';
    .token {
        background-color:lighten($link, 55);
        padding:10px;
        border-radius:5px;

        input.actual-token {
            width:100%;
            background-color:inherit;
            border:none;
            font-size:13px;
        }

    }
</style>
